import { render, staticRenderFns } from "./achievementComparisonTable.vue?vue&type=template&id=df8cc7c2&scoped=true"
import script from "./achievementComparisonTable.vue?vue&type=script&lang=js"
export * from "./achievementComparisonTable.vue?vue&type=script&lang=js"
import style0 from "./achievementComparisonTable.vue?vue&type=style&index=0&id=df8cc7c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8cc7c2",
  null
  
)

export default component.exports